import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import {CATALOG_ROUTE} from "../../utils/const";

const CatalogMenu = ({ categories }) => {
      const getImagePath = (imageName) => {
        return require(`../../assets/img/CatalogMenu/IconForBarline/${imageName}`);
      };

      return (
<div>
      <Accordion>
        <Navbar className="pt-0 sidenav">
          <Nav className="flex-column modalnav pt-0" as="ul">
            {categories.map((item) => (
              <Nav.Item as="li" key={item.id}>
                {item.childCatalogs.length > 0 ? (
                <Accordion.Item eventKey={String(item.id)} className="border-0">
                  <Accordion.Header>
                    <Nav.Link className="ps-0 me-4 fw-bold d-flex align-items-center" href={CATALOG_ROUTE + '/' + item.url}>
                      <img className="nav-icon me-3" src={getImagePath(item.imageIcon)} alt={item.name} />
                      {item.name}
                    </Nav.Link>
                  </Accordion.Header>
                  <Accordion.Body className="px-0">
                    {item.childCatalogs.map((childCatalog) => (
                      <Nav.Link key={childCatalog.id} className="ps-0 pe-3 border-bottom" href={CATALOG_ROUTE + '/' + childCatalog.url}>
                        {childCatalog.name}
                      </Nav.Link>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
                 ) : (
                  <Nav.Link
                  className="ps-0 me-4 fw-bold d-flex align-items-center" href={CATALOG_ROUTE + '/' + item.url}>
                  <img className="nav-icon me-3" src={getImagePath(item.imageIcon)} alt={item.name} />
                  {item.name}
                </Nav.Link>
              )}
              </Nav.Item>
            ))}
          </Nav>
        </Navbar>
      </Accordion>
    </div>
  );
};

export default CatalogMenu;